import { useQuery } from 'react-query';
import Patients from '../../services/Patients';
import { CUSTOMER_MEMBERSHIP_CONSENT } from '../../constants/reactQuery.keys';

export function useCustomerMembershipConsent(patientId: number) {
  return useQuery([CUSTOMER_MEMBERSHIP_CONSENT, patientId], () => Patients.getCustomerMembershipConsent(patientId));
}
